<template>
	<div v-parallax-fit="parallax" class="screen">
		<img src="/themes/rise-theme/dist/images/estate/character-view/holly/20_SocialMedia_1@2x.png" alt="">
	</div>
</template>

<script>
import { store } from '../../store';

export default {
	data() {
		return {
			store,
			subtitlesUrl: {
				'en': '/themes/rise-theme/resources/assets/audio/holly/3.srt',
				'es': '/themes/rise-theme/resources/assets/audio/holly/3_es.srt'
			},
			mutationObserver: null,
			parallax: [
				{
					start: 13800,
					end: 14500,
					fromStyle: { transform: 'translateX(-50%) translateY(-300%) rotateZ(2deg)' },
					toStyle: { transform: 'translateX(-50%) translateY(-50%) rotateZ(2deg)', marginTop: '10px' },
					easing: 'linear'
				},
				{
					start: 15550,
					end: 16500,
					fromStyle: { transform: 'translateX(-50%) translateY(-50%) rotateZ(2deg)', marginTop: '10px' },
					toStyle: { transform: 'translateX(-50%) translateY(300%) rotateZ(30deg)', marginTop: '5px' },
					easing: 'linear'
				}
			]
		}
	},
	created() {
		this.$watch('store.lang', newVal => {
			if (Object.values(this.subtitlesUrl).includes(this.$subtitlesUrl.value)) {
				this.$subtitlesUrl.value = this.subtitlesUrl[newVal]
			}
		}, { immediate: true });
	},
	mounted() {
		const self = this;
		const audio = '/themes/rise-theme/resources/assets/audio/holly/3.mp3';

		this.mutationObserver = new window.MutationObserver(mutationList => {
			mutationList.forEach(mutation => {
				if (mutation.target.style.marginTop == '10px') {
					self.$audioUrl.value = audio;
					self.$subtitlesUrl.value = this.subtitlesUrl[this.store.lang];
					self.$evidence.value = null;
					self.$readMore.value = '';
				}
			});
		});

		this.mutationObserver.observe(document.querySelector('.screen'), {
			attributes: true,
			attributeFilter: ['style']
		});
	},
	unmounted() {
		this.mutationObserver.disconnect();
	}
}
</script>

<style lang="scss" scoped>
.screen {
	position: absolute;
	top: 50%;
	left: 50%;
	z-index: 2;
	max-width: 900px;
	width: 100%;
	transition: all 0.1s linear;
}
</style>
